import React from "react";
import { Link, Typography } from "@mui/material";

// eslint-disable-next-line
export default {
  title: "Works",
  programNote: "Program note",
  performanceHistory: "Performance history",
  back: "Back",
  next: "Next",
  data: [
    {
      year: "2022",
      name: "El vacío inagotable",
      description: "Performatic ecosystem for string quartet",
      comments: (
        <>
          <Typography variant="caption" sx={{ fontStyle: "italic" }}>
            Commissioned by{" "}
            <Link
              variant="caption"
              sx={{ fontStyle: "italic" }}
              href="https://jackquartet.com/"
            >
              JACK Quartet
            </Link>{" "}
            through their JACK Studio program
          </Typography>
        </>
      ),
    },
    {
      year: "2022",
      name: "new piece",
      description: "for three male voices and three accordions",
      comments: (
        <>
          <Typography variant="caption" sx={{ fontStyle: "italic" }}>
            Created for the “Composing for Voice and Accordions” Workshop held
            at Darmstadt Summer Courses 2021
          </Typography>
        </>
      ),
    },
    {
      year: "2022",
      name: "new piece",
      description:
        "for electric guitar, electric keyboard, saxophone and electronics",
      comments: (
        <>
          <Typography variant="caption" sx={{ fontStyle: "italic" }}>
            Comissioned for{" "}
            <Link
              variant="caption"
              sx={{ fontStyle: "italic" }}
              href="https://soyuz21.ch/en"
            >
              Soyuz21
            </Link>{" "}
            by "ICST – Institute for Computer Music and Sound Technology" at
            Zurich University of the Arts as part of their artistic residencies
            program
          </Typography>
        </>
      ),
    },
    {
      year: "2022",
      name: "new piece",
      description: "for txistu, accordion and percussion",
      comments: (
        <>
          <Typography variant="caption" sx={{ fontStyle: "italic" }}>
            Comissioned by{" "}
            <Link
              variant="caption"
              sx={{ fontStyle: "italic" }}
              href="https://www.triozukan.com/"
            >
              Trio Zukan
            </Link>
          </Typography>
        </>
      ),
    },
    {
      year: "2022",
      name: "new piece",
      description: "for bass clarinet, double bass and piano",
      comments: (
        <>
          <Typography variant="caption" sx={{ fontStyle: "italic" }}>
            Commisioned by the Low Frequency Trio through their Low Frequency
            Oscillator call for pieces
          </Typography>
        </>
      ),
    },
    {
      year: "2021",
      name: "Como hilos de viento y luz",

      description:
        "Performatic ecosystem for VHS tapes, instruments and objects",
      comments: (
        <>
          <Typography variant="caption" sx={{ fontStyle: "italic" }}>
            Composed for the Yarn/Wire International Institute 2021
          </Typography>
        </>
      ),
      videos: [
        {
          id: "qZGhUKLgFpY",
          title: "Yarn/Wire",
        },
        {
          id: "jeK3CoYW29Y",
          title: "Kevin Zetina",
        },
        {
          id: "z2tYSfhXopw",
          title: "Yarn/Wire y Jeffrey Gavett",
        },
      ],
    },
    {
      year: "2021",
      name: "La oquedad rugiente",
      description: "for ondes Martenot, speakers and paper sheets",
      comments: (
        <>
          <Typography variant="caption" sx={{ fontStyle: "italic" }}>
            Commissioned by Alonso Huerta and the Discos Carnitas label
          </Typography>
        </>
      ),
      audio: [
        {
          url: "https://soundcloud.com/andres_guadarrama/la-oquedad-rugiente-ondes-martenot-speakers-and-paper-sheets-2021e.com",
          text: "Audio",
        },
      ],
    },
    {
      year: "2021",
      name: "Camino",
      description:
        "for one performer walking through an open field using a sonic clothing",
      comments: (
        <>
          <Typography variant="caption" sx={{ fontStyle: "italic" }}>
            Supported by “Ibermúsicas - Ayudas al sector musical en modalidad
            virtual 2020”
          </Typography>
        </>
      ),
    },
    {
      year: "2020",
      name: "En el umbral de la madre inconcebible",
      description:
        "Performatic ecosystem for 4 or more performers, 1 prepared tom and secondary instruments, objects and space",
      comments: (
        <>
          <Typography variant="caption" sx={{ fontStyle: "italic" }}>
            Piece awarded with the 2nd prize at the 4th National Composition
            Competition for Percussion Quartet, organized by SAFA Ensamble de
            Percusiones and CMMAS
          </Typography>
        </>
      ),
      programNote: [
        "A single instrument sprouts a complete sound ecosystem. Each performer interacts partially with the instrument, focusing exclusively on one aspect of it through simple and restricted actions that, however, have an impact on the entire ecosystem. Through the development of a sensitivity, awareness and care of all the forces that make up this ecosystem, sound can manifest its own identity, and invites both perform- ers and listeners to meet with it and inhabit it.",
      ],
      audio: [
        {
          url: "https://soundcloud.com/andres_guadarrama/en-el-umbral-de-la-madre-inconcebible-maqueta-mockup",
          text: "Audio",
        },
      ],
    },
    {
      year: "2019",
      name: "Lo furioso, lo verdaderamente animal que me sostiene, esto de grito ahorcado como un aullido en la garganta",
      description: "for two voices and two recorders",
      comments: (
        <>
          <Typography variant="caption" sx={{ fontStyle: "italic" }}>
            Composed for UMS ‘n JIP
          </Typography>
        </>
      ),
      performanceHistory: [
        "04.03.2019. UMS ’n JIP. The Latinoamerica Project. Kunstraum Walcheturm. Zürich, Switzerland",
        "03.03.2019. UMS ’n JIP. The Latinoamerica Project. Zeughaus Kultur. Brig-Glis, Switzerland",
        "01.03.2019. UMS ’n JIP. The Latinoamerica Project. Unternehmen Mitte. Bern, Switzerland",
        "28.02.2019. UMS ’n JIP. World Premiere. The Latinoamerica Project. Ono. Bern, Switzerland",
      ],
      programNote: [
        "Lo furioso, lo verdaderamente animal",
        "que me sostiene, lo que me guarda en pie",
        "con el rencor crecido, esto como de hueso,",
        "como de dientes que me muerden",
        "después de haber mascado el polvo,",
        "esto de sangre, esto de grito ahorcado",
        "como un aullido en la garganta,",
        "esto como un muro, como un sollozo",
        "largo de noche sin hogueras, lo animal,",
        "lo verdaderamente bronco que me duele en los ojos.",
        "Max Rojas, El turno del aullante",
      ],
    },
    {
      year: "2018",
      name: "La quemadura es el lenguaje con que juro, manos abiertas sobre el hielo",
      description: "for 2 performers and 1 electric bass",
      comments: (
        <>
          <Typography variant="caption" sx={{ fontStyle: "italic" }}>
            Composed with the support of the FONCA Jóvenes Creadores Fellowship
          </Typography>
        </>
      ),
      performanceHistory: [
        "30.05.2021 - Attica! Teatro Sergio Magaña. Mexico City, Mexico",
        "29.05.2021 - Attica! Teatro Sergio Magaña. Mexico City, Mexico",
        "24.04.2021 - XIN (Ángel Florido y Andrés Guadarrama). NUNC!4, Evanston, Illinois, USA",
        "26.03.2021 - XIN (Ángel Florido y Andrés Guadarrama). The 21st Century Guitar Conference. Lisboa, Portugal",
        "20.11.2020 - XIN (Ángel Florido y Andrés Guadarrama). Festival Aires. Mexico City, Mexico",
        "24.03.2019 - XIN (Ángel Florido y Andrés Guadarrama). Foro al Aire Libre, Casa del Lago. Mexico City, Mexico",
        "23.11.2018 - XIN (Ángel Florido y Andrés Guadarrama). Jóvenes Creadores 2017-2018 del FONCA final concert. Auditorio Mateo Herrera. León, Guanajuato, Mexico",
        "10.11.2018 - XIN (Ángel Florido y Andrés Guadarrama). Academia Sarti de Artes Integrales. Mexico City, Mexico",
        "09.09.2018 - XIN (Ángel Florido y Andrés Guadarrama). World Premiere. Vorágines IV. Sala Rosario Castellanos, Casa del Lago. Mexico City, Mexico",
      ],
      programNote: [
        "Two performers act conjointly in order to deliver one idea, one sonic stream, as irregular, delicate and to some extent, uncontrollable like playing with fire or painting in water. The multiple sounds that flow from the bass are a consequence of constrained and fragile actions between the performers that require a great amount of concentration and communication. The title of this piece is a poem by the Mexican writer Julian Herbert. This piece was composed with the support of the FONCA Young Creators grant 2017-2018.",
      ],
      videos: [
        {
          id: "CMNa2wwlouU",
          title: "Xin, primera versión",
        },
        {
          id: "w1hdQ1f-xg4",
          title: "Xin, segunda versión",
        },
      ],
      audio: [
        {
          url: "https://soundcloud.com/andres_guadarrama/la-quemadura-es-el-lenguaje-con-que-juro-manos-abiertas-sobre-el-hielo-2018",
          text: "Audio",
        },
      ],
    },
    {
      year: "2017",
      name: "Hand Shadows",
      description: "for accordion",
      comments: (
        <>
          <Typography variant="caption" sx={{ fontStyle: "italic" }}>
            Composed for Eva Zöllner as part of her “Caja de Viento” project,
            carried out during the dual year Mexico-Germany
          </Typography>
        </>
      ),
      videos: [
        {
          id: "nnbGc6Xq9y0",
          title: "Hand Shadows I",
        },
        {
          id: "LawgDknFprk",
          title: "Hand Shadows II",
        },
      ],
      performanceHistory: [
        "08.04.2017. Eva Zöllner. World Premiere. Caja de Viento. Museo de Arte de la SHCP-Antiguo Palacio del Arzobispado, Mexico City, Mexico",
      ],
      programNote: [
        "These two miniatures are inspired in the performing art of shadowgraphy, where different figures made by hand shadows where used to tell a story. The accordion is quite a sensitive instrument in which a tiny movement in the body of the performer results in an alteration of the sonority. Both miniatures construct delicate figures that are subject to constant transformation with a deliberate input of the performer’s inventive, instrument and unique physiological characteristics, so that every performance results in slightly different perceptions of these figures.",
      ],
    },
    {
      year: "2016",
      name: "Colotomy",
      description: "for piano",
      comments: (
        <>
          <Typography variant="caption" sx={{ fontStyle: "italic" }}>
            Composed for Ignacio Torner during the 2016 Laberintos Sonoros
            Summer Course
          </Typography>
        </>
      ),
      audio: [
        {
          url: "https://soundcloud.com/andres_guadarrama/colotomy-piano-2016",
          text: "Audio",
        },
      ],
      performanceHistory: [
        "18.10.2019. Joseph Houston. Donaueschinger Musiktage 2019. Donaueschingen, Germany",
        "23.08.2018. Pablo Miró Cortez. XL Foro Internacional de Música Nueva Manuel Enríquez. Museo Nacional de Arte, Mexico City, Mexico",
        "23.04.2018. Ignacio Torner. Jornadas de Música Contemporánea del Círculo Colombiano de Música Contemporánea. Fundación Gilberto Alzate Avendaño, Bogotá, Colombia",
        "02.12.2017. Ignacio Torner. World Premiere. Festival Encuentros Sonoros ’17. Sala Joaquín Turina, Sevilla, Spain",
      ],
      programNote: [
        "The term Colotomy was created by the Dutch ethnomusicologist Jaap Kunst to describe the relationships between structure, density, tempo, and instrumental function within a traditional gamelan composition. The initial attack establishes the relationships from which the different timbral and rhythmic planes of the piano are organized, and the way in which they unfold throughout the piece is the result of a personal interpretation of this concept of traditional Indonesian music. This piece was composed during the Composition Seminar “Laberintos Sonoros”, organized by composer Javier Torres Maldonado and is dedicated to Ignacio Torner, pianist of the Taller Sonoro Ensemble.",
      ],
    },
    {
      year: "2016",
      name: "Dial-Up",
      description: "for alto sax and electronics",
      comments: (
        <>
          <Typography variant="caption" sx={{ fontStyle: "italic" }}>
            Composed for Boglárka Nagy
          </Typography>
        </>
      ),
      audio: [
        {
          url: "https://soundcloud.com/andres_guadarrama/dial-up-alto-sax-and-electronics",
          text: "Audio",
        },
      ],
      performanceHistory: [
        "18.11.2016. Boglárka Nagy. Fundación Sebastián, Mexico City, Mexico",
        "28.10.2016. Boglárka Nagy. Fonometrías. CMMAS, Morelia, México",
        "24.08.2016. Boglárka Nagy. World Premiere. Fonometrías. Sala Carlos Chávez, CCU-UNAM. Mexico City, Mexico",
      ],
      programNote: [
        "Those who discovered the Internet in the late 90s nostalgically recall the sound produced when the connection started. The telephone plug, originally designed to transmit the human voice, was taken by a pair of modems that conversed in “zeros and ones” to establish protocols that allow a successful connection. The work started with a spectral analysis of the dial-up sound. The saxophone dialogues with the electronics in the same way a modem did it with another. Dial-up is a meditation on how this sound has become a testimony of the connection between the analogue and digital worlds; which have slowly erased its frontiers over time, establishing irrevocably as one.",
      ],
    },
    {
      year: "2016",
      name: "If everything returns to the one, where does the one return to?",
      description: "for solo violin",
      comments: (
        <>
          <Typography variant="caption" sx={{ fontStyle: "italic" }}>
            Composed for Tambuco during the Percussion Quartet Composition
            Workshop at Núcleo Integral de Composición (NICO)
          </Typography>
        </>
      ),
      audio: [
        {
          url: "https://soundcloud.com/andres_guadarrama/if-everything-return-to-the-one-where-does-the-one-return-to",
          text: "Audio",
        },
      ],
      performanceHistory: [
        "20.03.2016. Irvine Arditti. CIEM, Mexico City, Mexico",
      ],
    },
    {
      year: "2015",
      name: "Yugen",
      description: "for 1 vibraphone y 4 performers",
      comments: (
        <>
          <Typography variant="caption" sx={{ fontStyle: "italic" }}>
            Composed for Tambuco during the Percussion Quartet Composition
            Workshop at Núcleo Integral de Composición (NICO)
          </Typography>
          <Typography variant="caption" sx={{ fontStyle: "italic" }}>
            Recommended piece at the 63rd International Rostrum of Composers in
            Wrocław, Poland
          </Typography>
        </>
      ),
      audio: [
        {
          url: "https://soundcloud.com/andres_guadarrama/yugen-2015",
          text: "Audio",
        },
      ],
      performanceHistory: [
        "16.11.2017. Tambuco. Tambuco Japan Tour 2017. Tokyo, Japan",
        "01.08.2016. Tambuco. World Premiere. Sala Blas Galindo del Centro Nacional de la Artes, Mexico City, Mexico",
      ],
      programNote: [
        '"“A phosphorescent jewel gives off its glow and color in the dark and loses its beauty in the light of day. Were it not for shadows, there would be no beauty”.',
        "Junichiro Tanizaki, In Praise of Shadows",
        "This piece is intended for a single vibraphone played by a percussion quartet. This resulted in a variety of articulations such as the simultaneous employment of eight bows, glissandi bend notes and harmonics, producing a complex counterpoint of timbre variations.",
        "The vibraphone travels through contrasts of light and shadow: delicate and ethereal textures create a veil that vanishes like a whisper in the air; a series of strong rhythmic attacks degrade into barely audible strokes, like big rocky formations that transforms into polished river stones.",
        "“Yugen” is an appreciation of the imperfect and incomplete beauty that lies, with mysterious grace and melancholy, upon the depths of shadows and the trail left by time’s unavoidable pass.",
      ],
    },
  ],
};
